/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsCategoryInfoData } from './mands-category-info.data';
import { IMandsCategoryInfoProps, imageAlignment } from './mands-category-info.props.autogenerated';
import { checkImage } from '../../themes/mands/utilities/helper-functions';
import * as Msdyn365 from '@msdyn365-commerce/core';

interface IState {
    isCategoryImageAvailable: boolean;
    categoryImageUrl: string;
}
/**
 *
 * MandsCategoryInfo component
 * @extends {React.PureComponent<IMandsCategoryInfoProps<IMandsCategoryInfoData>,IState>}
 */
export default class MandsCategoryInfo extends React.PureComponent<IMandsCategoryInfoProps<IMandsCategoryInfoData>, IState> {
    constructor(props: IMandsCategoryInfoProps<IMandsCategoryInfoData>) {
        super(props);

        this.state = {
            isCategoryImageAvailable: false,
            categoryImageUrl: ''
        };
    }

    public componentDidMount = () => {
        const { data, context } = this.props;
        const category = data.category ? data.category.result : undefined;
        const categoryImagePath = category && category.RecordId ? `Categories/category_${category.RecordId}.png` : '';
        const apiSettings = context && context.request ? context.request.apiSettings : undefined;
        const categoryImageUrl =
            apiSettings && apiSettings.baseImageUrl && categoryImagePath ? apiSettings.baseImageUrl + categoryImagePath : '';
        checkImage(categoryImageUrl)
            .then(() => this.setState({ isCategoryImageAvailable: true, categoryImageUrl }))
            .catch(() => this.setState({ isCategoryImageAvailable: false, categoryImageUrl }));
    };
    public render(): JSX.Element | null {
        const {
            config,
            data: { category, vsiCategories },
            context: { request }
        } = this.props;
        console.log('data', this.props.data);
        if (!category) {
            return null;
        }
        const categoryTitle = category.result?.Name ? category.result?.Name : '';
        const vsiCategory = vsiCategories && vsiCategories.result?.filter(item => item.RecordId === category.result?.RecordId);
        const test = vsiCategory && vsiCategory[0].Description ? vsiCategory[0].Description : '';
        // const description = vsiCategory && vsiCategory[0].Description ? vsiCategory[0].Description.split('|') : '';
        // const schoolAdress = description.length > 0 ? description[0] : '';
        // const schoolWebsite = description.length > 1 ? description[1] : '';

        let left;
        let right;
        if (config.imageAlignment === imageAlignment.left) {
            right = this._renderImage(this.state.categoryImageUrl, categoryTitle);
            left = this._renderInfo(categoryTitle, test);
        } else {
            left = this._renderImage(this.state.categoryImageUrl, categoryTitle);
            right = this._renderInfo(categoryTitle, test);
        }
        const ignoreCategoryInHeader = [
            5637146829, // 'accessories',
            5637146834, // 'bags',
            5637146835, // 'caps',
            5637146836, // 'ties',
            // 'uniform by school',
            5637146830, // 'boys plain uniform',
            5637146837, // 'boys - coats and blazers',
            5637146838, // 'jumpers',
            5637146839, // 'pe kits',
            5637146843, // "Boys' T-shirts'",
            5637146840, // 'shirts & polo shirts',
            5637146842, // 'Sweatshirts'
            5637146841, // 'trousers & shorts',
            5637146831, // 'girls plain uniform',
            5637146844, // 'blouses & polo shirts',
            5637146845, // 'dresses & pinafores',
            5637146852, // 'Girls - Accessories'
            5637146846, // 'girls - coats and blazers',
            5637146847, // 'girls - pe kits',
            5637146851, // 'girls' T-Shirts',
            5637146848, // 'jumpers & cardigans',
            5637146850, // 'Sweatshirts & Cardigans'
            5637146849, // 'trousers & skirts',
            5637146832 // 'sale & offers',
            // 'sales & offers'
        ];

        const categoryId = category && category.result && category.result.RecordId ? category.result.RecordId : 0;
        const categoryExist = ignoreCategoryInHeader.indexOf(categoryId);
        const isMobile = request && request.device && request.device.Type === 'Mobile';
        return (
            <>
                {!isMobile && categoryExist === -1 && (
                    <div className='row align-items-center cat-feature'>
                        <div className='col-12'>
                            <div className='row'>
                                {left}
                                {right}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }

    private _renderImage(categoryImageUrl: string, categoryTitle: string): JSX.Element {
        return (
            <>
                {this.state.isCategoryImageAvailable && (
                    <div className='cat-header-image'>
                        <img src={categoryImageUrl} alt={categoryTitle} className='img-fluid p-3' />
                    </div>
                )}
            </>
        );
    }
    private _renderInfo(categoryTitle: string, test: string): JSX.Element {
        return (
            <div className='mand-plp-info'>
                <h4 className='title'>{categoryTitle}</h4>
                <div className='cat-description-wrap'>{<Msdyn365.RichTextComponent text={test} />}</div>
            </div>
        );
    }
}
